import {
  ProfitsStatisticsState,
  REQUEST_PROFITSTATISTICS,
  REQUEST_PROFITSTATISTICS_DONE
} from "./types";

const initialState: ProfitsStatisticsState = {
  isLoading: true,
  profitStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_PROFITSTATISTICS:
      return {
        isLoading: true,
        profitStatistics: action.payload
      };
    case REQUEST_PROFITSTATISTICS_DONE:
      return {
        isLoading: false,
        profitStatistics: action.payload
      };
    default:
      return state;
  }
}
